import Waypoint from "@/ts/base/Utils/Waypoint";

class ElementRevealer {
	protected elements: NodeListOf<HTMLElement>;
	protected reveiledIds: string[] = [];

	delay: number = 150;

	constructor(elements: NodeListOf<HTMLElement>) {
		this.elements = elements;
	}

	run(): void {
		const unveiled = this.getUnveiled();
		const elements: HTMLElement[][] = [];

		unveiled.forEach((item, index) => {
			if (item.classList.contains(Waypoint.InViewClass)) {
				const lineIndex = Number.parseInt(String(item.dataset.lineIndex));
				if (!elements[lineIndex]) {
					elements[lineIndex] = [];
				}
				elements[lineIndex].push(item);
			}
		});

		elements.forEach(line => {
			let delay = 0;
			line.forEach(item => {
				window.setTimeout(() => {
					item.classList.add("animated");
					this.reveiledIds.push(item.id);
				}, delay);
				delay += this.delay;
			});
		});
	}

	getUnveiled(): HTMLElement[] {
		const out: HTMLElement[] = [];

		this.elements.forEach((i, index) => {
			if (this.reveiledIds.indexOf(i.id) == -1) {
				out.push(i);
			}
		});

		return out;
	}
}

export default ElementRevealer;
